// extracted by mini-css-extract-plugin
export default {"tableWrap":"LinesCard_tableWrap__-3RBA"};